import { logger } from "@/shared/lib/logger";
import { deletePushToken } from "../api/push-tokens";
import { getCachedPushToken, setCachedPushToken } from "./token-cache";

/**
 * Best-effort removal of this device's push token from the server.
 * Must run BEFORE supabase.auth.signOut() — the DELETE needs the access token.
 * Never throws: a leftover token row must not block sign-out.
 */
export async function unregisterPushToken(): Promise<void> {
  const token = getCachedPushToken();
  if (!token) return;

  try {
    await deletePushToken(token);
  } catch (error) {
    logger.warn("Failed to unregister push token", { error: String(error) });
  }
  setCachedPushToken(null);
}
